import { DEFAULT_ROLES, SYSTEM_COMPONENTS_IDS } from "web/src/app/root/constants"

export const getInitialRoleState = (user) => {
    const state = {}
    const components = { ...SYSTEM_COMPONENTS_IDS }
    // if (user.original_role !== DEFAULT_ROLES.traplinked_admin) delete components[SYSTEM_COMPONENTS_IDS.customers]

    for (const [component] of Object.entries(components)) {
        state[component] = {
            create: false,
            read: false,
            update: false,
            delete: false
        }
    }
    return state
}

export const getComponents = (state, user) => {
    const components = new Set(Object.keys(state))

    // for security reasons we temporarily hiding user management
    components.delete(SYSTEM_COMPONENTS_IDS.user_management)

    if (user.original_role !== DEFAULT_ROLES.traplinked_admin) {
        components.delete(SYSTEM_COMPONENTS_IDS.customers)
    }
    return [...components]
}